import type { ScheduleForecastState } from "../../domain/weather";
import type { TeamAppModel } from "../../hooks/teamTypes";
import { ScheduleScreen } from "../schedule/ScheduleScreen";

interface ScheduleRouteProps {
  model: TeamAppModel;
  weatherByEntryId: Record<string, ScheduleForecastState>;
  onRetryWeather: () => void;
  weatherRefreshing?: boolean;
}

export function ScheduleRoute({
  model,
  weatherByEntryId,
  onRetryWeather,
  weatherRefreshing = false,
}: ScheduleRouteProps) {
  const { shell, schedule } = model;

  return (
    <ScheduleScreen
      teamName={schedule.teamName}
      entries={schedule.entries}
      series={schedule.series}
      seasons={schedule.seasons}
      activeSeasonId={schedule.activeSeasonId}
      players={schedule.players}
      serverBusy={schedule.serverBusy}
      actionStatus={schedule.actionStatus}
      onCreate={schedule.actions.createSchedule}
      onUpdate={schedule.actions.updateSchedule}
      onSelect={async (scheduleId) => {
        const succeeded = await schedule.actions.selectSchedule(scheduleId);
        if (succeeded) shell.setScreen("setup");
        return succeeded;
      }}
      onDelete={schedule.actions.deleteSchedule}
      onCreateSeries={schedule.actions.createSeries}
      onUpdateSeries={schedule.actions.updateSeries}
      onDeleteSeries={schedule.actions.deleteSeries}
      onOpenActive={() => shell.setScreen("game")}
      onOpenResult={(gameId) => {
        schedule.setResultGameId(gameId);
        shell.setScreen("result");
      }}
      weatherByEntryId={weatherByEntryId}
      onRetryWeather={onRetryWeather}
      weatherRefreshing={weatherRefreshing}
    />
  );
}
